import { render, staticRenderFns } from "./QuizTypeSelectModal.vue?vue&type=template&id=19bef77a&"
import script from "./QuizTypeSelectModal.vue?vue&type=script&lang=js&"
export * from "./QuizTypeSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizTypeSelectModal.vue?vue&type=style&index=0&id=19bef77a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports